export enum AuthorityInformative {
  DEFAULT_INFORMATIVE = '8.',
  DEFAULT_INFORMATIVE_EDIT = '8.1',
  CONFIGURATION_INFORMATIVE_NOTIFICATION_DISPLAY = '8.1.5',
  CONFIGURATION_INFORMATIVE_NOTIFICATION_DELETE = '8.1.6',
  CONFIGURATION_INFORMATIVE_NOTIFICATION_MARK_AS_READ = '8.1.7',

  MESSAGE_READ = '8.1.1',
  MESSAGE_CREATE = '8.1.2',
  MESSAGE_UPDATE = '8.1.3',
  MESSAGE_DELETE = '8.1.4',
}
